import { RadioGroup, RadioGroupItem } from './radio-group'
import { cn } from '@/lib/utils'

interface ColorPickerProps {
  field: {
    value: string | undefined
    onChange: (value: string) => void
  },
  options: { value: string; label: string, color: string }[]
}

export function ColorPickerLabeled({ field, options }: ColorPickerProps) {

  return (
    <RadioGroup
      onValueChange={field.onChange}
      defaultValue={field.value}
      className="flex gap-2"
    >
      {options.map((option) => (
        <>
        <RadioGroupItem
          key={option.value}
          value={option.value}
          id={option.value}
          title={option.label}
          className={cn(
            'size-6 border-0 shadow-none transition-all duration-200',
            `bg-${option.color}-500`
          )}
          aria-label={option.label}
        />{option.label}
        </>
      ))}
    </RadioGroup>
  )
}
